<template>
  <v-flex class="pa-3">
    <!-- <v-layout row wrap>
      <v-flex xs2 sm2>
        <label style="font-size:17px;top:15px;color:#333333;">Upload Logo Image :</label>
      </v-flex>
    </v-layout> -->
    <v-layout row wrap>
      <v-flex xs3 sm3 class="pt-2">
        <label style="font-size:17px;top:15px;color:#333333;">Upload Logo Image :</label>
      </v-flex>
      <v-flex xs9 sm9>
        <v-btn class="ml-0" @click="$emit('selectImage')">Choose Files</v-btn><br>
        <label style="font-size:17px;top:15px;color:#616A6B;">{{ selectedFile.logo_name }}</label>
      </v-flex>
    </v-layout>
    <!-- <v-layout row wrap>
      <v-flex>
        <label style="font-size:17px;top:15px;color:#333333;">Example logo image :</label>
      </v-flex>
    </v-layout> -->
    <v-layout row wrap class="my-3">
      <v-flex xs3 sm3 class="pt-3">
        <label style="font-size:17px;top:15px;color:#333333;">Example logo image :</label>
      </v-flex>
      <v-flex xs9 sm9>
        <img
          :src="store_data.store_image"
          :style="{width: (height*1.3) + 'px' ,  height: height , border: '1px solid gray' }"
          alt="Cropped Image"
          v-if="store_data.store_image && store_data.store_image != null"
        >
        <v-card :height="220.17 + 'px'" :width="(height*1.3) + 'px'" color="grey" class="text-xs-center pt-3" v-else>No image</v-card>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer/>
      <v-btn flat color="red" @click="$emit('closeDialog');">Back</v-btn>
      <v-btn color="primary" class="black--text" @click="$emit('toE3')">Continue</v-btn>
    </v-card-actions>
  </v-flex>
</template>

<script>
export default {
  props: ["store_data", "selectedFile"],
  data() {
    return {
      height: 300
    };
  },
  methods: {}
};
</script>

<style scoped>
</style>